module.exports = __webpack_public_path__ + "img/cover_dietz.d1066cdf.jpg";